import { DEFAULT_FORMAT } from '../enums/formats';

// The public entry (prompt, format, chosen topic, profile answers) survives the
// login round-trip in sessionStorage; nothing here is sent before sign-in.
export const DRAFT_KEY = 'ginastee:studio:entry:v1';
export const emptyEntry = () => ({ prompt: '', format: DEFAULT_FORMAT, instagram_handle: '' });

export function readEntry(storage = window.sessionStorage) {
  try { return fromOlderBuild(JSON.parse(storage.getItem(DRAFT_KEY))) || emptyEntry(); }
  catch { return emptyEntry(); }
}
// A chosen topic is a chip in the prompt, no longer its text: a draft saved when choosing
// it wrote its title as the prompt drops that copy, or the title would show twice.
const fromOlderBuild = draft => (draft?.topic && draft.prompt?.trim() === draft.topic.title ? { ...draft, prompt: '' } : draft);
export function saveEntry(entry, storage = window.sessionStorage) { storage.setItem(DRAFT_KEY, JSON.stringify(entry)); }
export function clearEntry(storage = window.sessionStorage) {
  try { storage.removeItem(DRAFT_KEY); } catch { /* Nothing left to recover. */ }
}

// Unsaved script edits are kept per owner and project until the server accepts
// them as a revision, so a reload or a failed autosave never loses text.
const editorKey = (owner, projectId) => `ginastee:studio:editor:v2:${owner}:${projectId}`;
export function readEditorDraft(owner, projectId, storage = window.localStorage) {
  try { return JSON.parse(storage.getItem(editorKey(owner, projectId))) || null; }
  catch { return null; }
}
export function saveEditorDraft(owner, projectId, draft, storage = window.localStorage) {
  storage.setItem(editorKey(owner, projectId), JSON.stringify(draft));
}
export function clearEditorDraft(owner, projectId, storage = window.localStorage) {
  try { storage.removeItem(editorKey(owner, projectId)); } catch { /* Already gone. */ }
}

// The same for arts: the edited document and caption, with the revision they were based on.
const artKey = (owner, projectId) => `ginastee:studio:art:v1:${owner}:${projectId}`;
export function readArtDraft(owner, projectId, storage = window.localStorage) {
  try { return JSON.parse(storage.getItem(artKey(owner, projectId))) || null; }
  catch { return null; }
}
export function saveArtDraft(owner, projectId, draft, storage = window.localStorage) {
  storage.setItem(artKey(owner, projectId), JSON.stringify(draft));
}
export function clearArtDraft(owner, projectId, storage = window.localStorage) {
  try { storage.removeItem(artKey(owner, projectId)); } catch { /* Already gone. */ }
}
